import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface UserSearch {
    name: string;
    email: string;
    showInactive: boolean;
    showResults: boolean;
    result: UserList[];
    loading: boolean;
}

interface UserList {
    id: number;
    name: string;
    company: string;
    department: string;
    extension: number;
    mobile: string;
    email: string;
    status: string;
}

export class UserSearchData extends React.Component<RouteComponentProps<{}>, UserSearch> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: '',
            email: '',
            showInactive: false,
            showResults: false,
            result: [],
            loading: true
        };

        
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=CreateEditUsers&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.setState({ loading: false });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addNew = () => {
        this.props.history.push("/user")
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    handleCheckboxChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.checked;
        this.setState(change)
    }

    reset = () => {
        this.setState({
            name: '',
            email: '',
            showInactive: false,
            result: [],
            showResults: false
        });
    }

    search = (e: any) => {
        e.preventDefault();
        //check to make sure at least one search field has been entered
        if (this.state.name || this.state.email) {
            this.searchUsers();
        } else {
            this.setState({ showResults: false });
            toast.error("Please enter at least one search item");
        }
    }

    async searchUsers() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/SearchUsers?SubId=' + user.sub + '&Name=' + this.state.name + '&Email=' + this.state.email + '&ShowInactive=' + this.state.showInactive, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ showResults: true, result: res.data });
        })
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUserSearch();

        return (
            <div>
                <div className="makeitflexspacebetween">
                    <h1>User Search</h1>
                    <button className="defaultbutton defaultbutton__small marginTop10" type='button' onClick={this.addNew}>Add New</button>
                </div>
                {contents}
            </div>
        )
    }

    renderUserSearch = () => {
        return (<form onSubmit={this.search}>
            <div>
                <label className="input-group--inline" htmlFor="name">
                    <span className="label">Name</span>
                    <input className="input" type="text" id="name" name="name" value={this.state.name} onChange={(e) => this.handleChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="email">
                    <span className="label">Email</span>
                    <input className="input" type="text" id="email" name="email" value={this.state.email} onChange={(e) => this.handleChange(e)}></input>
                </label>
 
                <label className="input-group--inline" htmlFor="inactive">
                    <span className="label">Show Inactive</span>
                    <input className="input" type="checkbox" id="inactive" name="showInactive" checked={this.state.showInactive} onChange={(e) => this.handleCheckboxChange(e)}></input>
                </label>

                <button className="defaultbutton" type='submit'>Search</button>
                <button className="defaultbutton marginLeft10" type='button' onClick={this.reset}>Reset</button>
            </div>
            <div className="row">
                <hr></hr>
            </div>
            <div className={this.state.showResults ? 'overflowAuto' : 'hidden'}>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Company</th>
                            <th>Extn.</th>
                            <th>Mobile</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.result.map(user =>
                            <tr key={user.id}>
                                <td className="hidden">{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.email}</td>
                                <td>{user.company}</td>
                                <td>{user.extension}</td>
                                <td>{user.mobile}</td>
                                <td>{user.status}</td>
                                <td>
                                    <Link to={'/user/' + user.id}>
                                        Open
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


        </form>);

    }
}

